jQuery.extend(jQuery.validator.messages, {
	required: FmtMessage.getMessage('js.general.required'),
	remote: FmtMessage.getMessage('js.general.remote'),
	email: FmtMessage.getMessage('js.general.email'),
	url: FmtMessage.getMessage('js.general.url'),
	date: FmtMessage.getMessage('js.general.date'),
	dateISO: FmtMessage.getMessage('js.general.dateISO'),
	number: FmtMessage.getMessage('js.general.number'),
	digits: FmtMessage.getMessage('js.general.digits'),
	creditcard: FmtMessage.getMessage('js.general.creditcard'),
	equalTo: FmtMessage.getMessage('js.general.equalTo'),
	accept: FmtMessage.getMessage('js.general.accept'),
	maxlength: FmtMessage.getMessage('js.general.maxlength'),
	minlength: FmtMessage.getMessage('js.general.minlength'),
	rangelength: FmtMessage.getMessage('js.general.rangelength'),
	range: FmtMessage.getMessage('js.general.range'),
	max: FmtMessage.getMessage('js.general.max'),
	min: FmtMessage.getMessage('js.general.min'),
	tcno: FmtMessage.getMessage('js.general.tcno'),
	irsano: FmtMessage.getMessage('js.general.irsano'),
	tripleDateBoundries: "",
	doubleDateBoundries: "",
	doubleYearBoundries: "",
	doubleDayBoundries: "",
	doubleMonthBoundries: "",
	gsm: FmtMessage.getMessage('js.general.gsm'),
	cc_owner_name : FmtMessage.getMessage('js.creditcard.name.warning'),
	cvc_warn : FmtMessage.getMessage('js.creditcard.cvc.warning'),
	gender_warn : FmtMessage.getMessage('js.person.gender.warning'),
	passNo_warn : FmtMessage.getMessage('js.person.passNo.warning'),
	cc_expire_month_warn : FmtMessage.getMessage('js.creditcard.expireMonth.warning'),
	cc_expire_year_warn : FmtMessage.getMessage('js.creditcard.expireYear.warning'),
	busNameLength : FmtMessage.getMessage('js.bus.name.length.warning'),
	latinChars : FmtMessage.getMessage('js.latinchars.warning'),
	milesWarning : FmtMessage.getMessage('js.miles.warning'),
    taxno: FmtMessage.getMessage('js.general.taxno'),
	duplicatePassenger: FmtMessage.getMessage('js.passenger.duplicate'),
	hesCode: FmtMessage.getMessage('js.passenger.hescode.not_empty')

});


function getFmtMessagesWithArgs(s){
	var i = arguments.length;
	while (i > 0) {
		i--;
	    s = s.replace(new RegExp('\\{' + (i-1) + '\\}', 'gm'), arguments[i]);
	}
	return s;
};